import { render, staticRenderFns } from "./BillExchangeProduct.vue?vue&type=template&id=1678c470&scoped=true"
import script from "./BillExchangeProduct.vue?vue&type=script&lang=js"
export * from "./BillExchangeProduct.vue?vue&type=script&lang=js"
import style0 from "./BillExchangeProduct.vue?vue&type=style&index=0&id=1678c470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1678c470",
  null
  
)

export default component.exports